// extracted by mini-css-extract-plugin
module.exports = {"v-icon":"NsAddressPl_v-icon_HqIMH","nsAddressForm":"NsAddressPl_nsAddressForm_3omOX","dualColumn":"NsAddressPl_dualColumn_1w6oZ","firstCol":"NsAddressPl_firstCol_13vaE"};